import React, { useEffect, useState } from 'react'
import './styles.scss'
import { getStaticImage } from 'utils/statics'

const TextInputField = (props) => {
  const {
    defaultValue,
    value,
    type = 'text',
    onChange,
    id,
    customInput,
    className,
    name,
    invalid,
    classNameWrapper,
    label,
    errorMessage,
    placeholder,
    disabled,
    maxCharacter = 0,
    ...rest
  } = props

  const [error, setError] = useState(errorMessage)

  useEffect(() => {
    setError(errorMessage)
  }, [errorMessage])

  return (
    <div className={`text-input-field-wrapper ${classNameWrapper}`}>
      {label && <label className='text-input-label'>{label}</label>}
      <div className='container_max_character'>
        <input
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          type={type}
          onChange={({ target }) => {
            if (onChange) onChange(target.value)
          }}
          className={`text-input ${disabled ? 'disabled' : ''} ${className}`}
          disabled={disabled}
          {...rest}
          maxLength={maxCharacter > 0 ? maxCharacter : -1}
        />
        <div className='text-input-field-wrapper__actions-container'>
          {value ? (
            <button className='text-input-field-wrapper__icon-btn' onClick={() => onChange('')}>
              <figure>
                <img src={getStaticImage('/icons/icon-close-slim-grey.svg')} alt='Clean' />
              </figure>
            </button>
          ) : null}
          {maxCharacter > 0 ? (
            <span>
              {value?.length || 0}/{maxCharacter}
            </span>
          ) : null}
        </div>
      </div>
      {error && <span className='text-input-error-message'>{error}</span>}
    </div>
  )
}

export default TextInputField
